<template>
	<transition name="slide-fade">
		<div v-if="show" class="toast" :class="'toast-' + type">
			<div class="toast-icon">
				<div class="icon-circle icon-success" v-if="type == 'success'">
					<svg viewBox="0 0 24 24">
						<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="white" />
					</svg>
				</div>
				<div class="icon-circle icon-error" v-else>
					<svg viewBox="0 0 24 24">
						<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="white" />
					</svg>
				</div>
			</div>
			<div class="toast-content">
				<div class="toast-message">{{ message }}</div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
        inject: ['i18n'],
		props: {
			message: String,
			type: {
				type: String,
				default: 'success'
			},
			duration: {
				type: Number,
				default: 2000
			}
		},
		data() {
			return {
				show: false
			}
		},
		mounted() {
			this.show = true
			setTimeout(() => {
				this.show = false
			}, this.duration)
		}
	}
</script>

<style scoped>
	.toast {
		position: fixed;
		top: 30%;
		left: 50%;
		transform: translateX(-50%);
		padding: 16px 24px;
		border-radius: 8px;
		box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
		z-index: 9999;
		display: flex;
		max-width: 320px;
		width: auto;
		background: white;
		border: 2px solid;
	}

	.toast.toast-success {
		border-color: #ccf1cc;
	}

	.toast.toast-error {
		border-color: #f7d9dd;
	}

	.icon-circle {
		width: 28px;
		height: 28px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.icon-success {
		background-color: #52c41a;
	}

	.icon-error {
		background-color: #f5222d;
	}

	.toast-icon {
		margin-right: 16px;
		display: flex;
		align-items: center;
	}

	.toast-icon svg {
		width: 16px;
		height: 16px;
		fill: white;
	}

	.toast.toast-success .toast-icon svg {
		fill: #52c41a;
	}

	.toast.toast-error .toast-icon svg {
		fill: #f5222d;
	}

	.toast-title {
		font-size: 15px;
		font-weight: 700;
		margin-bottom: 6px;
		color: #333;
	}

	.toast-message {
		font-size: 14px;
		color: #555;
		line-height: 1.8;
	}

	.slide-fade-enter-active {
		animation: bounce-in 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
	}

	.slide-fade-leave-active {
		transition: all 0.1s ease-out;
	}

	.slide-fade-enter-from,
	.slide-fade-leave-to {
		transform: translate(-50%, -30px);
		opacity: 0;
	}

	@keyframes bounce-in {
		0% {
			transform: translate(-50%, -20px) scale(0.95);
			opacity: 0;
		}

		50% {
			transform: translate(-50%, -10px) scale(1.05);
		}

		80% {
			transform: translate(-50%, 5px) scale(0.98);
		}

		100% {
			transform: translate(-50%, 0) scale(1);
			opacity: 1;
		}
	}
</style>